const commonReportSx = (backgroundColor: string) => ({
  backgroundColor,
  borderRadius: '7.2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
});

export const laborReportsSx = commonReportSx('#E0700B');
export const inventoryReportSx = commonReportSx('#0D315E');
export const salesReportSx = commonReportSx('#139A7F');
export const kitchenReportSx = commonReportSx('#D53964');
export const menuReportsSx = commonReportSx('#4C90E6');
export const favoritesReportsSx = commonReportSx('#EEC226');
export const customReportsSx = commonReportSx('#9F72D0');

export const iconSx = { color: 'white', fontSize: '20px' };
export const smallSx = { width: '24px', height: '24px' };
export const mediumSx = { width: '36px', height: '36px' };
